import { StyleSheet } from 'aphrodite';
import { brandSecondary, titles } from '../../../web/styles/colors';

export const styleSheet = StyleSheet.create({
	continueButton: {
		minWidth: '136px !important',
	},
	footer: {
		alignItems: 'center',
		display: 'flex',
		justifyContent: 'space-between',
		width: '100%',
	},
	selectTrigger: {
		minWidth: 340,
		marginBottom: 16,
	},
	heading: {
		color: brandSecondary,
		fontSize: 18,
		margin: '19px 0 11px 0',
	},
	text: {
		color: titles,
		fontSize: 14,
		margin: '0 0 22px',
	},
	confirmationDialog: {
		maxWidth: 400,
	},
	wrapper: {
		alignItems: 'center',
		display: 'flex',
		flexDirection: 'column',
		padding: '0px 33px 20px',
	},
});
